export const getExpirationDate = (): string => {
  let date = new Date();
  date.setDate(date.getDate() + 1);
  return date.toISOString();
};

export const validExpiration = (expiration: string | null | undefined): boolean => {
  const currentDate = new Date();
  return expiration !== null && expiration !== undefined && currentDate < new Date(expiration);
};

export const formatSecondsToDaysValue = (totalSeconds: number): number => {
  const total = Number(totalSeconds);
  if (isNaN(total) || total <= 0) return 0;
  return total / 86400; // Seconds / Total seconds in a day
};
